import { Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';
import { TellentGroup, TellentGroupKind } from '@core/tellent-types';
import {
  AvatarComponent,
  type AvatarShape,
  ButtonComponent,
  CheckboxComponent,
  DialogBodyComponent,
  DialogComponentI,
  DialogFooterComponent,
  DialogHeaderComponent,
  DialogRef,
  GroupComponent,
  HeadingComponent,
  IconName,
} from '@core/user-interface-legacy';

type DialogData = {
  group: TellentGroup;
};

@Component({
  selector: 'remove-group-confirmation-dialog',
  imports: [
    ButtonComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    TranslatePipe,
    AvatarComponent,
    HeadingComponent,
    CheckboxComponent,
    GroupComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './remove-group-confirmation-dialog.component.html',
  styleUrl: './remove-group-confirmation-dialog.component.less',
})
export class RemoveGroupConfirmationDialogComponent implements DialogComponentI<
  DialogData,
  null | boolean
> {
  private readonly dialog = inject(DialogRef);
  protected readonly icons: Record<TellentGroupKind, { name: IconName; shape: AvatarShape }> = {
    [TellentGroupKind.Group]: {
      name: 'account-group',
      shape: 'oval',
    },
    [TellentGroupKind.Department]: {
      name: 'departments-hierarchy-tree',
      shape: 'square',
    },
  };
  protected readonly translationKeys = {
    [TellentGroupKind.Group]: {
      header: 'tlc.remove_group_dialog.header',
      groupMembers: 'tlc.remove_group_dialog.group_members',
      desc1: 'tlc.remove_group_dialog.desc_1',
      desc2: 'tlc.remove_group_dialog.desc_2',
      checkboxLabel: 'tlc.remove_group_dialog.checkbox_label',
      confirm: 'tlc.remove_group_dialog.confirm',
    },
    [TellentGroupKind.Department]: {
      header: 'tlc.remove_department_dialog.header',
      groupMembers: 'tlc.remove_department_dialog.department_members',
      desc1: 'tlc.remove_department_dialog.desc_1',
      desc2: 'tlc.remove_department_dialog.desc_2',
      checkboxLabel: 'tlc.remove_department_dialog.checkbox_label',
      confirm: 'tlc.remove_department_dialog.confirm',
    },
  };
  protected group: TellentGroup;

  protected checkboxControl = new FormControl(false, {
    nonNullable: true,
  });

  public setDialogData(data: DialogData): void {
    this.group = data.group;
  }

  protected close() {
    this.dialog.close();
  }

  protected confirm(): void {
    this.dialog.close(true);
  }
}
